// LUMINA · pages/vajra/components/EnergyInsightCard.jsx
// Phase 39D: extracted from VajraPortal.jsx — Phase 4 P0 LUMINA↔Vajra bridge

import React from 'react';

export default function EnergyInsightCard({ insight }) {
  const [visible, setVisible] = React.useState(true);
  const [entered, setEntered] = React.useState(false);
  const [closing, setClosing] = React.useState(false);

  React.useEffect(() => {
    const t = setTimeout(() => setEntered(true), 40);
    return () => clearTimeout(t);
  }, []);

  if (!visible || !insight || !insight.has_report) return null;

  const GDL   = "#D4AF37";
  const score = insight.stability_index;
  const isAlert = score !== null && score < 85;
  const title = isAlert ? "今日能量护持提示" : "能量对治洞见";
  const elements = insight.five_elements || {};
  const ir = insight.interaction_report || {};
  const penalties = ir.earthly_penalties || [];
  const clashes   = ir.earthly_clashes   || [];

  // Slide-in from right + closing animation
  const slideStyle = {
    transform: closing ? "translateX(110%)" : entered ? "translateX(0)" : "translateX(110%)",
    opacity:   closing ? 0 : entered ? 1 : 0,
    transition: closing
      ? "transform 0.35s cubic-bezier(0.4,0,1,1), opacity 0.30s ease"
      : "transform 0.45s cubic-bezier(0.16,1,0.3,1), opacity 0.35s ease",
  };

  const handleDedicate = () => {
    setClosing(true);
    setTimeout(() => setVisible(false), 380);
  };

  return (
    <div style={{
      ...slideStyle,
      position: "fixed",
      right: 16,
      top: 80,
      width: 320,
      zIndex: 200,
      background: "linear-gradient(135deg, rgba(30,10,5,0.92) 0%, rgba(60,30,5,0.88) 100%)",
      border: `1px solid rgba(212,175,55,${isAlert ? "0.55" : "0.30"})`,
      borderRadius: 14,
      padding: "18px 20px 14px",
      backdropFilter: "blur(16px)",
      WebkitBackdropFilter: "blur(16px)",
      overflow: "hidden",
      boxShadow: isAlert
        ? "0 0 0 1px rgba(212,175,55,0.18), 0 0 24px rgba(212,175,55,0.12), inset 0 1px 0 rgba(212,175,55,0.10)"
        : "0 0 0 1px rgba(212,175,55,0.10), 0 4px 20px rgba(0,0,0,0.25)",
    }}>

      {/* Glow overlay */}
      <div style={{
        position:"absolute", top:0, left:0, right:0, height:1,
        background:"linear-gradient(90deg,transparent,rgba(212,175,55,0.35),transparent)",
        pointerEvents:"none",
      }}/>

      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
        <span style={{fontSize:16, filter: isAlert ? "drop-shadow(0 0 4px rgba(212,175,55,0.6))" : "none"}}>☸</span>
        <span style={{
          color: GDL, fontSize: 10, letterSpacing: 2.5, fontWeight: 600,
          textShadow: isAlert ? "0 0 8px rgba(212,175,55,0.4)" : "none",
        }}>{title}</span>
        {score !== null && (
          <span style={{
            marginLeft:"auto", fontSize:10, letterSpacing:.5,
            color: isAlert ? GDL : "rgba(212,175,55,0.5)",
            border:`1px solid ${isAlert ? "rgba(212,175,55,0.4)" : "rgba(212,175,55,0.2)"}`,
            borderRadius:8, padding:"1px 8px",
            background: isAlert ? "rgba(212,175,55,0.08)" : "transparent",
          }}>
            稳定指数 {score}
          </span>
        )}
      </div>

      {/* Interaction alerts */}
      {(penalties.length > 0 || clashes.length > 0) && (
        <div style={{marginBottom:10}}>
          {penalties.map((p, i) => (
            <div key={i} style={{
              display:"flex", alignItems:"flex-start", gap:8,
              background:"rgba(212,175,55,0.06)", borderRadius:8,
              padding:"8px 10px", marginBottom:6,
              borderLeft:`2px solid rgba(212,175,55,0.45)`,
            }}>
              <span style={{color:GDL,fontSize:12,marginTop:1}}>⚡</span>
              <div>
                <div style={{color:"rgba(255,255,255,0.9)",fontSize:12,lineHeight:1.6}}>
                  {p.note || `检测到${p.branches.join("")}${p.type}`}
                </div>
                <div style={{color:"rgba(212,175,55,0.7)",fontSize:11,marginTop:2}}>
                  {p.dharma}
                </div>
              </div>
            </div>
          ))}
          {clashes.map((c, i) => (
            <div key={i} style={{
              display:"flex", alignItems:"flex-start", gap:8,
              background:"rgba(212,175,55,0.05)", borderRadius:8,
              padding:"8px 10px", marginBottom:6,
              borderLeft:`2px solid rgba(212,175,55,0.30)`,
            }}>
              <span style={{color:GDL,fontSize:12,marginTop:1}}>〰</span>
              <div>
                <div style={{color:"rgba(255,255,255,0.85)",fontSize:12,lineHeight:1.6}}>
                  检测到{c.branches.join("")}地支六冲（{c.pillars.join(" × ")}）
                </div>
                <div style={{color:"rgba(212,175,55,0.7)",fontSize:11,marginTop:2}}>
                  {c.dharma}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Insight text */}
      <div style={{color:"rgba(255,255,255,0.80)",fontSize:13,lineHeight:1.8,marginBottom:10}}>
        {insight.insight_text}
      </div>

      {/* Element chips */}
      <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:12}}>
        {Object.entries(elements).map(([el,pct])=>{
          const isLow = typeof pct==="number" && pct < 12;
          const isHigh = typeof pct==="number" && pct > 50;
          return (
            <span key={el} style={{
              fontSize:10, letterSpacing:.3,
              color: isLow ? GDL : isHigh ? "rgba(255,180,50,0.9)" : "rgba(212,175,55,0.55)",
              border:`1px solid ${isLow?"rgba(212,175,55,0.45)":isHigh?"rgba(255,180,50,0.30)":"rgba(212,175,55,0.15)"}`,
              borderRadius:10, padding:"2px 8px",
              fontWeight: (isLow||isHigh) ? 600 : 400,
              background: isHigh ? "rgba(255,140,0,0.06)" : "transparent",
            }}>
              {el}{typeof pct==="number"?` ${pct.toFixed(0)}%`:""}{isLow?" ⚠":""}{isHigh?" ▲":""}
            </span>
          );
        })}
      </div>

      {/* Footer: dedicate button */}
      <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",borderTop:"1px solid rgba(212,175,55,0.10)",paddingTop:10}}>
        {insight.primary_dharma && (
          <span style={{fontSize:10,color:"rgba(212,175,55,0.45)",marginRight:"auto",letterSpacing:.5}}>
            {insight.primary_dharma}
          </span>
        )}
        <button onClick={handleDedicate} style={{
          background:"rgba(212,175,55,0.10)",
          border:"1px solid rgba(212,175,55,0.30)",
          borderRadius:8,
          color:GDL,
          fontSize:11,letterSpacing:1.5,
          padding:"5px 14px",
          cursor:"pointer",
          transition:"background 0.2s",
        }}
          onMouseEnter={e=>e.target.style.background="rgba(212,175,55,0.20)"}
          onMouseLeave={e=>e.target.style.background="rgba(212,175,55,0.10)"}
        >回向</button>
      </div>
    </div>
  );
}
